<template>
    <div @dblclick="openEdit" style="font-size: 8pt; line-height: 1.5;">
    <div><strong>CÓDIGO:</strong> {{ form.codigo }}</div>
    <div><strong>VERSIÓN:</strong> {{ form.version }}</div>
    <div><strong>FECHA DE CREACIÓN:</strong> {{ form.fechaCreacion }}</div>
    <div><strong>ÚLTIMA REVISIÓN:</strong> {{ form.ultimaRevision }}</div>
    <!-- <div><strong>Páginas:</strong> {{ form.paginas }}</div> -->
    <!-- <div v-if="form.anexo"><strong>Anexos:</strong> {{ form.anexo }}</div> -->

    <v-dialog v-model="dialog" max-width="500px" append-to-body>
      <v-card>
        <v-card-title>
          <span class="headline">Editar Encabezado</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6">
                <v-text-field v-model="editForm.codigo" label="Código"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field v-model="editForm.version" label="Versión"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field v-model="editForm.fechaCreacion" label="Fecha Creación"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field v-model="editForm.ultimaRevision" label="Última Revisión"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field v-model="editForm.paginas" label="Páginas"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field v-model="editForm.anexo" label="Anexos"></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false">Cancelar</v-btn>
          <v-btn color="blue darken-1" text @click="save">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</div>
</template>

<script>
    import _sGenParam from "../../services/General/ParameterService";
    
export default {
    name: "DocumentHeaderControl",
  props: {
    paramName: {
      type: String,
      required: true,
    },
    defaultData: {
      type: Object,
      default: () => ({
        codigo: "",
        version: "",
        fechaCreacion: "",
        ultimaRevision: "",
        paginas: "",
        anexo: "",
      }),
    },
  },
  data() {
    return {
      form: {
        codigo: "",
        version: "",
        fechaCreacion: "",
        ultimaRevision: "",
        paginas: "",
        anexo: "",
      },
      editForm: {},
      dialog: false,
      headerAttributes: null,
    };
  },
  created() {
    this.form = { ...this.defaultData };
    this.load();
  },
  methods: {
    load() {
      const userId = this.$fun ? this.$fun.getUserID() : this.$store.getters.userId;
      _sGenParam
        .listoptions({ Search: this.paramName }, userId)
        .then((resp) => {
          if (resp.status === 200 && resp.data.length) {
            this.headerAttributes = resp.data[0];
            try {
              const parsed = JSON.parse(this.headerAttributes.PrmValue);
              this.form = { ...this.form, ...parsed };
            } catch (e) {
              console.error("Error parseando encabezado", e);
            }
          }
        });
    },
    openEdit() {
      if (this.$fun && !this.$fun.isAdmin()) return;
      this.editForm = { ...this.form };
      this.dialog = true;
    },
    save() {
      const userId = this.$fun ? this.$fun.getUserID() : this.$store.getters.userId;
      const data = { ...(this.headerAttributes || {}) };
      data.PrmName = data.PrmName || this.paramName;
      data.PrmValue = JSON.stringify(this.editForm);
      
      // If it's a new parameter (headerAttributes was null), we might need to set other required fields like PrmGroup if the API requires it.
      // Assuming the API handles creation with just Name and Value or we are updating existing ones mostly.
      // If PrmID is missing, it's an insert.

      _sGenParam.save(data, userId).then((resp) => {
        if (resp.status === 200) {
          this.form = { ...this.editForm };
          // Update headerAttributes with response to get the ID if it was new
          if (resp.data) {
             this.headerAttributes = resp.data;
          }
          this.dialog = false;
          this.$fun.alert("Encabezado actualizado", "success");
        }
      });
    },
  },
};
</script>
